/*
 * MnZ Buybox: Malen nach Zahlen nach eigenem Foto (SCHNAUD)
 * Gehört zu sections/main-product-mnz.liquid + snippets/mnz-*.liquid
 *
 * Aufbau:
 *  - MnzCore: reine Logik ohne DOM (Varianten, Preise, Resize-Planung, Fehlertexte). Wird im Test-Harness direkt geprüft.
 *  - <mnz-buybox>: DOM-Schicht. Nutzt das Formular und den AJAX-Add des Themes (Symmetry: form.product-purchase-form,
 *    select.original-selector, theme:cartchanged), damit Cart-Drawer, Zähler und Analytics wie gewohnt laufen.
 *  - Leinwand zweistufig (Karten "Gerollt" / "Gespannte Leinwand" mit Unteroptionen), Info-Popup zur Leinwand
 *    (<dialog>, auf dem Handy als Bottom-Sheet), Nachfüllset als klickbare Karte. An der Varianten-Logik ändert das nichts.
 *  - Foto-Editor + Farbvorschau: assets/mnz-editor.js (MnzEditor, vorher geladen). Die Buybox liefert Foto, Arbeitskopie,
 *    Größe/Format und schreibt die Bestell-Eigenschaften (Ausschnitt sichtbar, Original + Rohdaten versteckt mit "_").
 *
 * Keine Secrets: Upload läuft unsigned über Cloud-Name + Preset aus den Section-Settings.
 */
(function (root) {
  'use strict';

  /* =====================================================================
   * Core (pure)
   * ===================================================================== */
  var Core = {};

  Core.MAX_UPLOAD_BYTES = 10485760; // Cloudinary Free: image_max_size_bytes
  Core.TARGET_BYTES = 9000000; // Ziel nach dem Verkleinern: unter 9 MB
  Core.TARGET_PIXELS = 24000000; // Ziel nach dem Verkleinern: max. ca. 24 MP (Cloudinary-Limit 25 MP)
  Core.IOS_CANVAS_MAX_PIXELS = 16777216; // iOS/iPadOS Safari: max. Canvas-Fläche
  Core.CANVAS_MAX_DIMENSION = 16384;

  Core.uniq = function (list) {
    var out = [];
    for (var i = 0; i < list.length; i++) {
      if (out.indexOf(list[i]) === -1) out.push(list[i]);
    }
    return out;
  };

  Core.isRefill = function (value, keyword) {
    return !!keyword && String(value).indexOf(keyword) !== -1;
  };

  // "24 Farben + Nachfüllset" -> "24 Farben"
  Core.baseColor = function (value, keyword) {
    var str = String(value);
    if (!Core.isRefill(str, keyword)) return str;
    return str.slice(0, str.indexOf(keyword)).replace(/[\s+&,\-–]+$/, '').trim();
  };

  Core.createModel = function (cfg) {
    var optionNames = cfg.optionNames || [];
    var variants = cfg.variants || [];
    var m = {
      variants: variants,
      optionNames: optionNames,
      colorsIndex: typeof cfg.colorsIndex === 'number' ? cfg.colorsIndex : -1,
      keyword: cfg.refillKeyword || ''
    };
    m.values = optionNames.map(function (_, i) {
      return Core.uniq(variants.map(function (v) { return v.options[i]; }));
    });
    m.baseColors = [];
    m.hasRefillValues = false;
    if (m.colorsIndex >= 0 && m.values[m.colorsIndex]) {
      m.baseColors = Core.uniq(m.values[m.colorsIndex].map(function (v) { return Core.baseColor(v, m.keyword); }));
      m.hasRefillValues = m.values[m.colorsIndex].some(function (v) { return Core.isRefill(v, m.keyword); });
    }
    m.refillEnabled = !!cfg.refillEnabled && m.hasRefillValues;
    return m;
  };

  // Werte, die im UI für Option i angezeigt werden (Farben: nur Basiswerte, Nachfüllset kommt über die Checkbox)
  Core.tileValues = function (m, i) {
    return i === m.colorsIndex ? m.baseColors : m.values[i];
  };

  Core.refillValueFor = function (m, base) {
    var list = m.values[m.colorsIndex] || [];
    for (var i = 0; i < list.length; i++) {
      if (Core.isRefill(list[i], m.keyword) && Core.baseColor(list[i], m.keyword) === base) return list[i];
    }
    return null;
  };

  Core.plainValueFor = function (m, base) {
    var list = m.values[m.colorsIndex] || [];
    for (var i = 0; i < list.length; i++) {
      if (!Core.isRefill(list[i], m.keyword) && list[i] === base) return list[i];
    }
    return null;
  };

  // Auswahl (UI-Zustand) -> echte Optionswerte der Variante, oder null wenn es die Kombination nicht gibt
  Core.fullValues = function (m, sel) {
    var vals = sel.values.slice();
    if (m.colorsIndex >= 0) {
      var base = vals[m.colorsIndex];
      var real = sel.refill ? Core.refillValueFor(m, base) : Core.plainValueFor(m, base);
      if (real === null) return null;
      vals[m.colorsIndex] = real;
    }
    return vals;
  };

  Core.findVariantByValues = function (m, vals) {
    if (!vals) return null;
    for (var i = 0; i < m.variants.length; i++) {
      var v = m.variants[i];
      var ok = true;
      for (var j = 0; j < vals.length; j++) {
        if (v.options[j] !== vals[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  };

  Core.variantFor = function (m, sel) {
    return Core.findVariantByValues(m, Core.fullValues(m, sel));
  };

  Core.findVariantById = function (m, id) {
    for (var i = 0; i < m.variants.length; i++) {
      if (String(m.variants[i].id) === String(id)) return m.variants[i];
    }
    return null;
  };

  Core.selectionFromVariant = function (m, v) {
    var values = v.options.slice();
    var refill = false;
    if (m.colorsIndex >= 0) {
      refill = Core.isRefill(values[m.colorsIndex], m.keyword);
      values[m.colorsIndex] = Core.baseColor(values[m.colorsIndex], m.keyword);
    }
    return { values: values, refill: refill };
  };

  // Startzustand: Variante aus Liquid (?variant= oder Vorauswahl). Nachfüllset ausgeschaltet -> Gegenstück ohne Nachfüllset.
  Core.initialSelection = function (m, variantId) {
    var v = Core.findVariantById(m, variantId) || m.variants[0];
    var sel = Core.selectionFromVariant(m, v);
    if (sel.refill && !m.refillEnabled) {
      var plain = { values: sel.values.slice(), refill: false };
      if (Core.variantFor(m, plain)) sel = plain;
    }
    return sel;
  };

  Core.withValue = function (sel, i, value) {
    var values = sel.values.slice();
    values[i] = value;
    return { values: values, refill: sel.refill };
  };

  // Nach einer Änderung an Option i: exakte Kombination wenn verfügbar, sonst die verfügbare Variante mit diesem Wert,
  // die möglichst viele der übrigen Wahlen behält (frühere Optionen wiegen schwerer). Nie in eine Sackgasse laufen.
  Core.resolveChange = function (m, sel, i, value) {
    var wanted = Core.withValue(sel, i, value);
    var exact = Core.variantFor(m, wanted);
    if (exact && exact.available) return { sel: wanted, variant: exact };

    var best = null;
    var bestScore = -1;
    for (var k = 0; k < m.variants.length; k++) {
      var v = m.variants[k];
      if (!v.available) continue;
      var cand = Core.selectionFromVariant(m, v);
      if (cand.refill && !m.refillEnabled) continue;
      if (cand.values[i] !== value) continue;
      var score = 0;
      var n = cand.values.length;
      for (var j = 0; j < n; j++) {
        if (j !== i && cand.values[j] === wanted.values[j]) score += Math.pow(2, n - j);
      }
      if (cand.refill === wanted.refill) score += 1;
      if (score > bestScore) { bestScore = score; best = { sel: cand, variant: v }; }
    }
    return best || { sel: wanted, variant: exact };
  };

  Core.tileStatus = function (m, sel, i, value) {
    var exact = Core.variantFor(m, Core.withValue(sel, i, value));
    if (exact && exact.available) return 'available';
    for (var k = 0; k < m.variants.length; k++) {
      var v = m.variants[k];
      if (!v.available) continue;
      var cand = Core.selectionFromVariant(m, v);
      if (cand.refill && !m.refillEnabled) continue;
      if (cand.values[i] === value) return 'adjust'; // wählbar, andere Optionen werden angepasst
    }
    return 'unavailable';
  };

  // Aufpreis eines Werts relativ zum günstigsten Wert einer Gruppe von Werten derselben Option (bei sonst gleicher Auswahl).
  // null = nicht berechenbar.
  Core.groupDelta = function (m, sel, i, value, group) {
    var own = Core.variantFor(m, Core.withValue(sel, i, value));
    if (!own) return null;
    var min = null;
    for (var k = 0; k < group.length; k++) {
      var v = Core.variantFor(m, Core.withValue(sel, i, group[k]));
      if (v && (min === null || v.price < min)) min = v.price;
    }
    return min === null ? null : own.price - min;
  };

  // Aufpreis einer Kachel relativ zum günstigsten Wert dieser Option
  Core.optionDelta = function (m, sel, i, value) {
    return Core.groupDelta(m, sel, i, value, Core.tileValues(m, i));
  };

  // Leinwand zweistufig. c = {index, rolled, subs, defaultSub} aus der Section.
  // open: Karte "Gespannt" aufgeklappt; sub: markierte Unteroption (aktuelle, sonst die zuletzt gewählte)
  Core.canvasView = function (sel, c, lastSub) {
    var cur = sel.values[c.index];
    var open = c.subs.indexOf(cur) !== -1;
    return { open: open, rolled: cur === c.rolled, sub: open ? cur : lastSub };
  };

  // Welche Unteroption ein Klick auf "Gespannte Leinwand" wählt: die zuletzt gewählte, sonst die Standard-Unteroption,
  // sonst die erste wählbare. Erst exakt verfügbare, dann solche, bei denen andere Optionen angepasst werden. null = keine.
  Core.pickSub = function (m, sel, c, lastSub) {
    var order = Core.uniq([lastSub, c.defaultSub].concat(c.subs)).filter(function (v) { return c.subs.indexOf(v) !== -1; });
    for (var pass = 0; pass < 2; pass++) {
      for (var k = 0; k < order.length; k++) {
        var status = Core.tileStatus(m, sel, c.index, order[k]);
        if (status === 'available' || (pass === 1 && status === 'adjust')) return order[k];
      }
    }
    return null;
  };

  // Nachfüllset an/aus: neue Auswahl, oder null wenn es die Variante nicht gibt bzw. sie nicht verfügbar ist
  Core.toggleRefill = function (m, sel, checked) {
    var next = { values: sel.values.slice(), refill: !!checked };
    var v = Core.variantFor(m, next);
    return v && v.available ? next : null;
  };

  Core.refillInfo = function (m, sel) {
    if (!m.refillEnabled) return { exists: false, available: false, delta: null };
    var withR = Core.variantFor(m, { values: sel.values, refill: true });
    var without = Core.variantFor(m, { values: sel.values, refill: false });
    return {
      exists: !!withR,
      available: !!(withR && withR.available),
      delta: withR && without ? withR.price - without.price : null
    };
  };

  // Entspricht theme.Shopify.formatMoney (Symmetry), Eingabe in Cent
  Core.formatMoney = function (cents, format) {
    var fmt = format || '€{{amount_with_comma_separator}}';
    function fmtNum(num, decimals, thousands, decimal) {
      if (isNaN(num) || num === null) return '0';
      var parts = (num / 100).toFixed(decimals).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(re);
    if (!match) return fmtNum(cents, 2, '.', ',');
    var out;
    switch (match[1]) {
      case 'amount': out = fmtNum(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': out = fmtNum(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fmtNum(cents, 2, '.', ','); break;
      case 'amount_with_space_separator': out = fmtNum(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': out = fmtNum(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_comma_separator': out = fmtNum(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': out = fmtNum(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': out = fmtNum(cents, 2, "'", '.'); break;
      case 'amount_with_decimal_separator': out = fmtNum(cents, 2, '.', '.'); break;
      default: out = fmtNum(cents, 2, ',', '.');
    }
    return fmt.replace(re, out);
  };

  Core.formatDelta = function (delta, format, zeroText) {
    if (delta === null || delta === undefined) return '';
    if (delta === 0) return zeroText || '';
    return (delta > 0 ? '+' : '−') + Core.formatMoney(Math.abs(delta), format);
  };

  Core.detectFormat = function (w, h) {
    if (!w || !h) return null;
    return w > h ? 'landscape' : 'portrait';
  };

  // Kauf-Button: welcher Modus gilt gerade
  Core.ctaMode = function (st) {
    if (!st.variant) return 'unavailable';
    if (!st.variant.available) return 'soldout';
    if (st.busy) return 'uploading';
    if (!st.hasPhoto) return 'upload';
    return 'add';
  };

  // Dateiart bestimmen (Typ ist bei HEIC auf manchen Systemen leer)
  Core.fileKind = function (name, type) {
    var t = String(type || '').toLowerCase();
    var n = String(name || '').toLowerCase();
    if (t === 'image/heic' || t === 'image/heif' || /\.(heic|heif)$/.test(n)) return 'heic';
    if (t === 'image/jpeg' || t === 'image/jpg' || t === 'image/pjpeg' || (!t && /\.(jpe?g)$/.test(n))) return 'jpeg';
    if (t === 'image/png' || (!t && /\.png$/.test(n))) return 'png';
    if (t === 'image/webp' || (!t && /\.webp$/.test(n))) return 'webp';
    if (t.indexOf('image/') === 0) return 'other-image';
    if (!t && /\.(gif|bmp|avif|tiff?)$/.test(n)) return 'other-image';
    return 'unsupported';
  };

  // Resize-Planung. info: {width, height, bytes, kind, orientation}; opts: {canvasMaxPixels}
  Core.planResize = function (info, opts) {
    opts = opts || {};
    var targetPixels = Math.min(Core.TARGET_PIXELS, opts.canvasMaxPixels || Core.TARGET_PIXELS);
    var maxDim = opts.canvasMaxDimension || Core.CANVAS_MAX_DIMENSION;
    var w = info.width;
    var h = info.height;
    var tooManyPixels = w * h > Core.TARGET_PIXELS;
    var tooBig = info.bytes > Core.TARGET_BYTES;
    var rotated = info.kind === 'jpeg' && info.orientation > 1;
    var convert = info.kind === 'other-image';
    var reencode = tooManyPixels || tooBig || rotated || convert;
    var scale = 1;
    if (w * h > targetPixels) scale = Math.sqrt(targetPixels / (w * h));
    if (w * scale > maxDim) scale = maxDim / w;
    if (h * scale > maxDim) scale = Math.min(scale, maxDim / h);
    var tw = Math.max(1, Math.floor(w * scale));
    var th = Math.max(1, Math.floor(h * scale));
    // Canvas-Limit greift auch, wenn das Original unter 24 MP liegt, aber neu kodiert werden muss (z.B. iOS + gedreht)
    return {
      reencode: reencode,
      width: reencode ? tw : w,
      height: reencode ? th : h,
      reasons: { tooManyPixels: tooManyPixels, tooBig: tooBig, rotated: rotated, convert: convert }
    };
  };

  // Qualitäts-/Größenstufen für die JPEG-Kodierung, bis die Datei unter TARGET_BYTES liegt
  Core.encodeSteps = [
    { scale: 1, quality: 0.92 },
    { scale: 1, quality: 0.86 },
    { scale: 1, quality: 0.8 },
    { scale: 0.85, quality: 0.86 },
    { scale: 0.72, quality: 0.84 },
    { scale: 0.6, quality: 0.82 }
  ];

  // EXIF-Orientierung aus den ersten Bytes eines JPEG lesen (1 = normal, 0 = unbekannt)
  Core.readJpegOrientation = function (buffer) {
    try {
      var view = new DataView(buffer);
      if (view.byteLength < 4 || view.getUint16(0) !== 0xFFD8) return 0;
      var offset = 2;
      while (offset + 4 <= view.byteLength) {
        var marker = view.getUint16(offset);
        if ((marker & 0xFF00) !== 0xFF00) return 0;
        if (marker === 0xFFDA) return 1; // Start of Scan, keine EXIF gefunden
        var size = view.getUint16(offset + 2);
        if (marker === 0xFFE1 && offset + 10 <= view.byteLength && view.getUint32(offset + 4) === 0x45786966) {
          var tiff = offset + 10;
          if (tiff + 8 > view.byteLength) return 0;
          var little = view.getUint16(tiff) === 0x4949;
          var ifd = tiff + view.getUint32(tiff + 4, little);
          if (ifd + 2 > view.byteLength) return 0;
          var entries = view.getUint16(ifd, little);
          for (var i = 0; i < entries; i++) {
            var entry = ifd + 2 + i * 12;
            if (entry + 12 > view.byteLength) return 0;
            if (view.getUint16(entry, little) === 0x0112) {
              var o = view.getUint16(entry + 8, little);
              return o >= 1 && o <= 8 ? o : 1;
            }
          }
          return 1;
        }
        offset += 2 + size;
      }
    } catch (e) {
      return 0;
    }
    return 0;
  };

  // Fehler der Upload-API in einen Fehlerschlüssel übersetzen
  Core.classifyUploadError = function (status, responseText) {
    if (status === 0) return 'network';
    var msg = '';
    try { msg = String((JSON.parse(responseText).error || {}).message || ''); } catch (e) { msg = ''; }
    var low = msg.toLowerCase();
    if (low.indexOf('too large') !== -1 || low.indexOf('megapixel') !== -1 || low.indexOf('resolution') !== -1 || low.indexOf('too many pixels') !== -1 || status === 413) return 'too_large';
    if (low.indexOf('format') !== -1 && low.indexOf('not allowed') !== -1) return 'unsupported';
    if (low.indexOf('invalid image') !== -1) return 'unsupported';
    if (status === 408 || status === 429 || status >= 500) return 'network';
    return 'generic';
  };

  Core.isRetryable = function (errorKey) {
    return errorKey === 'network' || errorKey === 'generic';
  };

  // Cloudinary-Vorschaubild (kleine, browserfähige Ableitung; gleiche Transformation wie im Warenkorb)
  Core.thumbUrl = function (secureUrl) {
    return String(secureUrl || '').replace('/image/upload/', '/image/upload/c_limit,w_160,h_160,f_auto,q_auto/');
  };

  root.MnzCore = Core;

  /* =====================================================================
   * DOM-Schicht
   * ===================================================================== */
  if (typeof window === 'undefined' || !window.customElements || window.customElements.get('mnz-buybox')) return;

  // 2x1-JPEG mit EXIF-Orientierung 6: dreht der Browser selbst, kommt es als 1x2 an
  var ORIENT_TEST_SRC = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wAARCAABAAIDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDkJv8AXP8A7x/nRRRX29D+FH0RjW/iS9Wf/9k=';

  var autoOrientPromise = null;
  function browserAutoOrients() {
    if (!autoOrientPromise) {
      autoOrientPromise = new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () { resolve(img.width === 1 && img.height === 2); };
        img.onerror = function () { resolve(true); };
        img.src = ORIENT_TEST_SRC;
      });
    }
    return autoOrientPromise;
  }

  function isIOS() {
    var ua = navigator.userAgent || '';
    return /iP(hone|ad|od)/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('decode')); };
      img.src = src;
    });
  }

  function readSlice(file, bytes) {
    var blob = file.slice(0, bytes);
    if (blob.arrayBuffer) return blob.arrayBuffer();
    return new Promise(function (resolve, reject) {
      var fr = new FileReader();
      fr.onload = function () { resolve(fr.result); };
      fr.onerror = function () { reject(fr.error); };
      fr.readAsArrayBuffer(blob);
    });
  }

  function canvasToBlob(canvas, quality) {
    return new Promise(function (resolve) {
      if (canvas.toBlob) {
        canvas.toBlob(function (b) { resolve(b); }, 'image/jpeg', quality);
      } else {
        try {
          var data = atob(canvas.toDataURL('image/jpeg', quality).split(',')[1]);
          var arr = new Uint8Array(data.length);
          for (var i = 0; i < data.length; i++) arr[i] = data.charCodeAt(i);
          resolve(new Blob([arr], { type: 'image/jpeg' }));
        } catch (e) {
          resolve(null);
        }
      }
    });
  }

  // Zeichnet das Bild in Zielgröße; dreht nur selbst, wenn der Browser die EXIF-Orientierung nicht anwendet
  function drawToCanvas(img, width, height, orientation, manualOrient) {
    var swap = manualOrient && orientation >= 5 && orientation <= 8;
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('canvas');
    ctx.fillStyle = '#ffffff'; // transparente PNGs bekommen weißen statt schwarzen Hintergrund
    ctx.fillRect(0, 0, width, height);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    var dw = swap ? height : width;
    var dh = swap ? width : height;
    if (manualOrient) {
      switch (orientation) {
        case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
        case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
        case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
        case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
        case 6: ctx.transform(0, 1, -1, 0, width, 0); break;
        case 7: ctx.transform(0, -1, -1, 0, width, height); break;
        case 8: ctx.transform(0, -1, 1, 0, 0, height); break;
        default: break;
      }
    }
    // Große Verkleinerungen in Halbschritten, damit nichts flimmert oder verpixelt.
    // dw/dh sind (wie sw/sh) in der Ausrichtung der Quelle, die Drehung macht die Transformation oben.
    var source = img;
    var sw = img.naturalWidth || img.width;
    var sh = img.naturalHeight || img.height;
    while (sw / 2 > dw && sh / 2 > dh && sw * sh > 4000000) {
      var step = document.createElement('canvas');
      step.width = Math.round(sw / 2);
      step.height = Math.round(sh / 2);
      var sctx = step.getContext('2d');
      if (!sctx) break;
      sctx.imageSmoothingEnabled = true;
      sctx.imageSmoothingQuality = 'high';
      sctx.drawImage(source, 0, 0, step.width, step.height);
      if (source !== img) { source.width = 0; source.height = 0; } // Zwischenstufe sofort freigeben (iOS: Canvas-Speicherlimit)
      source = step;
      sw = step.width;
      sh = step.height;
    }
    ctx.drawImage(source, 0, 0, dw, dh);
    if (source !== img) { source.width = 0; source.height = 0; }
    return canvas;
  }

  /**
   * Bereitet eine Datei für den Upload vor.
   * Ergebnis: {blob, filename, width, height, previewUrl} oder Fehler mit .mnzError = Schlüssel
   */
  function prepareFile(file) {
    var kind = Core.fileKind(file.name, file.type);
    var fail = function (key) { var e = new Error(key); e.mnzError = key; throw e; };

    if (kind === 'unsupported') return Promise.reject(Object.assign(new Error('unsupported'), { mnzError: 'unsupported' }));

    if (kind === 'heic') {
      if (file.size > Core.MAX_UPLOAD_BYTES) return Promise.reject(Object.assign(new Error('heic_too_large'), { mnzError: 'heic_too_large' }));
      // HEIC geht unverändert an Cloudinary. Vorschau/Maße nur, wenn der Browser HEIC selbst lesen kann (Safari).
      var heicUrl = URL.createObjectURL(file);
      return loadImage(heicUrl).then(function (img) {
        return { blob: file, filename: file.name, width: img.naturalWidth, height: img.naturalHeight, previewUrl: heicUrl };
      }, function () {
        URL.revokeObjectURL(heicUrl);
        return { blob: file, filename: file.name || 'foto.heic', width: 0, height: 0, previewUrl: null };
      });
    }

    var url = URL.createObjectURL(file);
    var orientationPromise = kind === 'jpeg'
      ? readSlice(file, 262144).then(Core.readJpegOrientation, function () { return 0; })
      : Promise.resolve(1);

    return Promise.all([loadImage(url), orientationPromise, browserAutoOrients()]).then(function (res) {
      var img = res[0];
      var orientation = res[1] || 1;
      var auto = res[2];
      var manual = !auto && orientation > 1;
      var w = img.naturalWidth;
      var h = img.naturalHeight;
      if (manual && orientation >= 5) { var t = w; w = h; h = t; }
      var plan = Core.planResize({ width: w, height: h, bytes: file.size, kind: kind, orientation: orientation }, {
        canvasMaxPixels: isIOS() ? Core.IOS_CANVAS_MAX_PIXELS : Core.TARGET_PIXELS
      });
      var work = makeWorkCopy(img, w, h, orientation, manual);
      if (!plan.reencode) {
        return { blob: file, filename: file.name, width: w, height: h, previewUrl: url, work: work };
      }
      var baseName = String(file.name || 'foto').replace(/\.[^.]+$/, '') || 'foto';
      var attempt = function (idx) {
        var step = Core.encodeSteps[idx];
        var tw = Math.max(1, Math.floor(plan.width * step.scale));
        var th = Math.max(1, Math.floor(plan.height * step.scale));
        var canvas;
        try {
          canvas = drawToCanvas(img, tw, th, orientation, manual);
        } catch (e) {
          if (work) { work.width = 0; work.height = 0; }
          fail('too_large'); // Canvas zu groß für das Gerät
        }
        return canvasToBlob(canvas, step.quality).then(function (blob) {
          canvas.width = 0; canvas.height = 0; // Speicher auf Mobilgeräten sofort freigeben
          if (!blob || !blob.size) fail('too_large');
          if (blob.size <= Core.TARGET_BYTES) {
            return { blob: blob, filename: baseName + '.jpg', width: tw, height: th, previewUrl: url, resized: true, work: work };
          }
          if (idx + 1 < Core.encodeSteps.length) return attempt(idx + 1);
          if (work) { work.width = 0; work.height = 0; }
          fail('too_large');
        });
      };
      return attempt(0);
    }, function () {
      // Browser kann das Bild nicht lesen: klein genug -> unverändert hochladen, Cloudinary prüft selbst
      URL.revokeObjectURL(url);
      if ((kind === 'jpeg' || kind === 'png' || kind === 'webp') && file.size <= Core.MAX_UPLOAD_BYTES) {
        return { blob: file, filename: file.name, width: 0, height: 0, previewUrl: null };
      }
      fail(kind === 'other-image' ? 'unsupported' : 'too_large');
    });
  }

  // Arbeitskopie für den Foto-Editor: aufrecht wie beim Upload, lange Kante max. 2000 px. null, wenn es nicht klappt
  // (dann lädt der Editor einmal ein JPEG von Cloudinary).
  function makeWorkCopy(img, w, h, orientation, manual) {
    var EC = root.MnzEditorCore;
    if (!EC || !w || !h) return null;
    try {
      var ws = EC.workSize(w, h);
      return drawToCanvas(img, ws.w, ws.h, orientation, manual);
    } catch (e) {
      return null;
    }
  }

  Core.prepareFile = prepareFile; // für den Test-Harness
  Core._drawToCanvas = drawToCanvas; // für den Test-Harness

  function setProp(input, value) {
    if (!input) return;
    input.value = value;
    input.disabled = !value; // leere Eigenschaften gar nicht erst mitschicken
  }

  class MnzBuybox extends HTMLElement {
    connectedCallback() {
      this._ready = true;
      if (this._initialized) {
        this._reattach();
        return;
      }
      this._initialized = true;
      try {
        this._setup();
      } catch (err) {
        if (window.console) console.error('[MnZ Buybox]', err);
        this._fatal();
      }
    }

    disconnectedCallback() {
      this._ready = false;
      if (this.state && this.state.busy) {
        this._abortUpload();
        this.state.busy = false;
        this.state.phase = 'error';
        this.state.error = 'network';
      }
      if (this._guide && this._guide.hasAttribute('open')) this._closeGuide();
      if (this.editor) {
        this.editor.closeDialogs();
        this.editor._killWorker(); // wird bei Bedarf neu gestartet
      }
      this._lockScroll(false); // 'close' feuert nicht zuverlässig, wenn der Dialog mit aus dem DOM fällt
      if (this._ctaObserver) this._ctaObserver.disconnect();
      if (this._stickyObserver) this._stickyObserver.disconnect();
      if (this._sticky && this._sticky.parentNode) this._sticky.parentNode.removeChild(this._sticky);
    }

    // Nur falls das Element im DOM verschoben wird (Listener am Element bleiben bestehen)
    _reattach() {
      if (!this.cta) return;
      if (this._ctaObserver) this._ctaObserver.observe(this.cta, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
      if (this._sticky) {
        document.body.appendChild(this._sticky);
        if (this._stickyObserver) this._stickyObserver.observe(this.cta);
      }
      this._render();
    }

    /* ---------- Setup ---------- */
    _setup() {
      var cfgEl = this.querySelector('script[data-mnz-config]');
      this.cfg = JSON.parse(cfgEl.textContent);
      this.s = this.cfg.strings || {};
      this.model = Core.createModel(this.cfg);
      this.canvas = this.cfg.canvas && this.cfg.canvas.subs && this.cfg.canvas.subs.length ? this.cfg.canvas : null;

      this.form = this.querySelector('form.product-purchase-form');
      this.select = this.form.querySelector('select[name="id"]');
      this.statusInput = this.form.querySelector('[data-mnz-prop-status]');
      this.statusValue = this.statusInput ? (this.statusInput.getAttribute('value') || '') : '';
      this.photoInput = this.form.querySelector('[data-mnz-prop-photo]');
      this.formatInput = this.form.querySelector('[data-mnz-prop-format]');
      this.originalInput = this.form.querySelector('[data-mnz-prop-original]');
      this.cropInput = this.form.querySelector('[data-mnz-prop-crop]');
      this.cta = this.form.querySelector('[data-mnz-cta]');
      this.fileInput = this.querySelector('[data-mnz-file]');
      this.uploadEl = this.querySelector('[data-mnz-upload]');

      this.state = {
        sel: Core.initialSelection(this.model, this.cfg.initialVariantId),
        format: 'portrait',
        formatAuto: false,
        photo: null, // {url, width, height}
        busy: false, // Foto wird vorbereitet oder hochgeladen
        progress: 0,
        error: null,
        prepared: null, // vorbereitete Datei für "Nochmal versuchen"
        lastSub: null // zuletzt gewählte Unteroption der gespannten Leinwand
      };
      if (this.canvas) {
        var startCanvas = this.state.sel.values[this.canvas.index];
        this.state.lastSub = this.canvas.subs.indexOf(startCanvas) !== -1 ? startCanvas
          : (this.canvas.subs.indexOf(this.canvas.defaultSub) !== -1 ? this.canvas.defaultSub : this.canvas.subs[0]);
      }
      this.variant = Core.variantFor(this.model, this.state.sel);
      this._uploadToken = 0;

      // Startvariante ins Theme-Select schreiben (ohne change: das Theme liest sie beim eigenen Start selbst)
      if (this.variant && String(this.select.value) !== String(this.variant.id)) this.select.value = String(this.variant.id);

      this._ctaIcons = {};
      var iconTpl = this.querySelector('template[data-mnz-cta-icons]');
      if (iconTpl && iconTpl.content) {
        var iconEls = iconTpl.content.querySelectorAll('[data-mnz-icon]');
        for (var ic = 0; ic < iconEls.length; ic++) this._ctaIcons[iconEls[ic].getAttribute('data-mnz-icon')] = iconEls[ic].innerHTML;
      }

      this._bindOptions();
      this._bindGuide();
      this._setupEditor();
      this._bindUpload();
      this._bindCta();
      this._setupSticky();
      this._render();
      this.classList.add('mnz-buybox--ready');
    }

    _fatal() {
      var msg = this.querySelector('[data-mnz-fatal]');
      if (msg) msg.hidden = false;
      var cta = this.querySelector('[data-mnz-cta]');
      if (cta) cta.disabled = true;
    }

    /* ---------- Optionen ---------- */
    _bindOptions() {
      var self = this;
      this.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.matches) return;
        try {
          if (t.matches('[data-mnz-option-input]')) {
            var idx = parseInt(t.getAttribute('data-option-index'), 10);
            var res = Core.resolveChange(self.model, self.state.sel, idx, t.value);
            self._applySelection(res.sel);
          } else if (t.matches('[data-mnz-canvas-group]')) {
            // Karte "Gespannte Leinwand": aufklappen und die zuletzt gewählte Unteroption wählen
            if (t.checked && self.canvas) {
              var sub = Core.pickSub(self.model, self.state.sel, self.canvas, self.state.lastSub);
              if (sub !== null) {
                self._applySelection(Core.resolveChange(self.model, self.state.sel, self.canvas.index, sub).sel);
              } else {
                self._render();
              }
            }
          } else if (t.matches('[data-mnz-format-input]')) {
            self.state.format = t.value === 'landscape' ? 'landscape' : 'portrait';
            self.state.formatAuto = false;
            self._render();
          } else if (t.matches('[data-mnz-refill-input]')) {
            var next = Core.toggleRefill(self.model, self.state.sel, t.checked);
            if (next) {
              self._applySelection(next);
            } else {
              t.checked = self.state.sel.refill;
            }
          }
        } catch (err) {
          if (window.console) console.error('[MnZ Buybox]', err);
        }
      });
    }

    _applySelection(sel) {
      this.state.sel = sel;
      if (this.canvas) {
        var canvasValue = sel.values[this.canvas.index];
        if (this.canvas.subs.indexOf(canvasValue) !== -1) this.state.lastSub = canvasValue;
      }
      this.variant = Core.variantFor(this.model, sel);
      this._render();
      this._syncThemeSelect();
    }

    // Variante an das Theme melden: aktualisiert URL (?variant=), Galerie-Variantenbild, Status-Klassen, Apps
    _syncThemeSelect() {
      if (!this.variant) return;
      if (String(this.select.value) !== String(this.variant.id)) {
        this.select.value = String(this.variant.id);
      }
      try {
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (err) {
        if (window.console) console.error('[MnZ Buybox] theme change', err);
      }
      this._renderCta(); // Theme überschreibt den Button-Text synchron, hier sofort wiederherstellen
    }

    /* ---------- Info-Popup Leinwand ---------- */
    // <dialog> mit showModal(): Rest der Seite inert (Fokus bleibt im Popup), ESC schließt nativ.
    // Dazu: Klick auf den Hintergrund, Scroll-Sperre, Fokus zurück auf den Info-Button.
    _bindGuide() {
      var self = this;
      var dialog = this.querySelector('[data-mnz-guide]');
      var opener = this.querySelector('[data-mnz-guide-open]');
      if (!dialog || !opener) return;
      this._guide = dialog;
      this._guideOpener = opener;

      opener.addEventListener('click', function (e) {
        e.preventDefault();
        self._openGuide();
      });
      // Nur schließen, wenn Drücken und Loslassen auf dem Hintergrund waren (nicht beim Markieren von Text)
      dialog.addEventListener('pointerdown', function (e) { self._guideDownOnBackdrop = e.target === dialog; });
      dialog.addEventListener('click', function (e) {
        var closer = e.target.closest ? e.target.closest('[data-mnz-guide-close]') : null;
        if (closer) {
          e.preventDefault();
          self._closeGuide();
        } else if (e.target === dialog && self._guideDownOnBackdrop !== false) {
          self._closeGuide();
        }
        self._guideDownOnBackdrop = null;
      });
      dialog.addEventListener('close', function () { if (!dialog.hasAttribute('open')) self._afterGuideClose(); }); // asynchron: nach erneutem Öffnen ignorieren
      // Chrome feuert nach ESC nicht immer 'close' (z.B. wenn der Fokus im scrollbaren Inhalt liegt).
      // Verlässlich ist das open-Attribut, daher zusätzlich beobachten. _afterGuideClose läuft nur einmal je Öffnen.
      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          if (!dialog.hasAttribute('open')) self._afterGuideClose();
        }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
      }
      // Ersatz ohne showModal (sehr alte Browser): ESC und Fokus-Falle selbst
      dialog.addEventListener('keydown', function (e) {
        if (self._guideNative) return;
        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault();
          self._closeGuide();
        } else if (e.key === 'Tab') {
          var f = dialog.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])');
          if (!f.length) return;
          var first = f[0];
          var last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });
    }

    _openGuide() {
      var d = this._guide;
      if (!d || d.hasAttribute('open')) return;
      this._lockScroll(true);
      this._guideActive = true;
      this._guideNative = false;
      if (typeof d.showModal === 'function') {
        try {
          d.showModal();
          this._guideNative = true;
        } catch (err) {
          this._guideNative = false;
        }
      }
      if (!this._guideNative) {
        d.setAttribute('open', '');
        d.classList.add('mnz-dialog--fallback');
      }
      var focusTarget = d.querySelector('[data-mnz-guide-close]');
      if (focusTarget) {
        try { focusTarget.focus({ preventScroll: true }); } catch (err) { focusTarget.focus(); }
      }
    }

    _closeGuide() {
      var d = this._guide;
      if (!d || !d.hasAttribute('open')) return;
      if (this._guideNative && typeof d.close === 'function') {
        d.close();
      } else {
        d.removeAttribute('open');
        d.classList.remove('mnz-dialog--fallback');
      }
      this._afterGuideClose();
    }

    _afterGuideClose() {
      if (!this._guideActive) return;
      this._guideActive = false;
      this._lockScroll(false);
      if (this._guideOpener && this._guideOpener.isConnected) {
        try { this._guideOpener.focus({ preventScroll: true }); } catch (err) { this._guideOpener.focus(); }
      }
    }

    // Scroll-Sperre der Seite; Scrollbar-Breite ausgleichen, damit am Desktop nichts springt
    _lockScroll(on) {
      var html = document.documentElement;
      var body = document.body;
      if (on) {
        if (this._scrollLocked) return;
        this._scrollLocked = true;
        var gap = window.innerWidth - html.clientWidth;
        this._bodyPadding = body.style.paddingRight;
        if (gap > 0) body.style.paddingRight = gap + 'px';
        html.classList.add('mnz-scroll-lock');
      } else if (this._scrollLocked) {
        this._scrollLocked = false;
        html.classList.remove('mnz-scroll-lock');
        body.style.paddingRight = this._bodyPadding || '';
      }
    }

    /* ---------- Foto-Editor + Farbvorschau (assets/mnz-editor.js) ---------- */
    _setupEditor() {
      var self = this;
      var el = this.querySelector('[data-mnz-editor]');
      var ed = this.cfg.editor || {};
      if (!el || !window.MnzEditor) return;
      try {
        this.editor = new window.MnzEditor(el, {
          host: this,
          strings: ed.strings || {},
          thresholds: ed.thresholds || {},
          strongMin: ed.strongMin || 0,
          lock: function (on) { self._lockScroll(on); },
          onChange: function () { self._writeProperties(); },
          onRotate: function (editor) { self._afterRotate(editor); },
          colors: function () { return self.model.baseColors.slice(); },
          selectedColor: function () { return self.model.colorsIndex >= 0 ? self.state.sel.values[self.model.colorsIndex] : null; },
          chooseColor: function (value) { self._chooseColor(value); }
        });
      } catch (err) {
        this.editor = null; // Bestellung klappt auch ohne Editor (Ausschnitt dann mittig)
        if (window.console) console.error('[MnZ Buybox] editor', err);
      }
    }

    // Seitenverhältnis des Rahmens aus Größe ("40x50 cm") und Format
    _editorFrame() {
      var EC = window.MnzEditorCore;
      var size = this.cfg.sizeIndex >= 0 ? this.state.sel.values[this.cfg.sizeIndex] : '';
      return { size: size, aspect: EC ? EC.frameAspect(size, this.state.format) : 0.8 };
    }

    // Nach dem Drehen: solange das Format automatisch gewählt ist, folgt es dem gedrehten Foto
    _afterRotate(editor) {
      if (!this.state.formatAuto) return;
      var d = editor.rotatedDims();
      var f = Core.detectFormat(d.w, d.h);
      if (f && f !== this.state.format) {
        this.state.format = f;
        this._render();
      }
    }

    // Farbvorschau: "<n> Farben wählen" setzt die Farbanzahl, das Nachfüllset bleibt, wenn es die Variante gibt
    _chooseColor(value) {
      var ci = this.model.colorsIndex;
      if (ci < 0) return;
      var res = Core.resolveChange(this.model, this.state.sel, ci, value);
      this._applySelection(res.sel);
    }

    /* ---------- Upload ---------- */
    _bindUpload() {
      var self = this;
      this.fileInput.addEventListener('change', function () {
        var file = self.fileInput.files && self.fileInput.files[0];
        if (file) self._handleFile(file);
        self.fileInput.value = ''; // gleiche Datei erneut wählbar
      });

      var retry = this.querySelector('[data-mnz-retry]');
      if (retry) {
        retry.addEventListener('click', function (e) {
          e.preventDefault();
          if (self.state.prepared && Core.isRetryable(self.state.error)) {
            self._upload(self.state.prepared);
          } else {
            self._openPicker();
          }
        });
      }

      var drop = this.querySelector('[data-mnz-drop]');
      if (drop) {
        ['dragenter', 'dragover'].forEach(function (type) {
          drop.addEventListener(type, function (e) {
            e.preventDefault();
            drop.classList.add('is-dragover');
          });
        });
        ['dragleave', 'dragend'].forEach(function (type) {
          drop.addEventListener(type, function () { drop.classList.remove('is-dragover'); });
        });
        drop.addEventListener('drop', function (e) {
          e.preventDefault();
          drop.classList.remove('is-dragover');
          var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
          if (file) self._handleFile(file);
        });
      }
    }

    _openPicker() {
      if (this.state.busy) return;
      try {
        this.fileInput.click();
      } catch (err) {
        if (window.console) console.error('[MnZ Buybox] picker', err);
      }
    }

    _handleFile(file) {
      var self = this;
      this._abortUpload();
      var token = ++this._uploadToken;
      if (this.editor) this.editor.clear(); // "Foto ändern": Editor zurück, Vorschau-Cache leer
      this._freeWork(this.state.prepared);
      this._revokePreview();
      this.state.photo = null;
      this.state.error = null;
      this.state.prepared = null;
      this.state.busy = true;
      this.state.phase = 'processing';
      this.state.progress = 0;
      this.state.previewUrl = null;
      this._render();

      prepareFile(file).then(function (prepared) {
        if (token !== self._uploadToken || !self._ready) {
          if (prepared.previewUrl) URL.revokeObjectURL(prepared.previewUrl);
          self._freeWork(prepared);
          return;
        }
        self.state.prepared = prepared;
        self.state.previewUrl = prepared.previewUrl;
        self._applyAutoFormat(prepared.width, prepared.height);
        self._upload(prepared);
      }).catch(function (err) {
        if (token !== self._uploadToken) return;
        if (window.console && !err.mnzError) console.error('[MnZ Buybox] prepare', err);
        self._fail(err && err.mnzError ? err.mnzError : 'generic');
      });
    }

    _applyAutoFormat(w, h) {
      var f = Core.detectFormat(w, h);
      if (!f) return;
      this.state.format = f;
      this.state.formatAuto = true;
    }

    _upload(prepared) {
      var self = this;
      this._abortUpload();
      var token = ++this._uploadToken;
      var cloud = this.cfg.cloudinary || {};
      this.state.busy = true;
      this.state.phase = 'uploading';
      this.state.progress = 0;
      this.state.error = null;
      this._render();

      var fd = new FormData();
      fd.append('file', prepared.blob, prepared.filename || 'foto.jpg');
      fd.append('upload_preset', cloud.preset);

      var xhr = new XMLHttpRequest();
      this._xhr = xhr;
      var stallTimer = null;
      var armStall = function (ms) {
        clearTimeout(stallTimer);
        stallTimer = setTimeout(function () {
          if (token === self._uploadToken) {
            self._abortUpload();
            self._fail('network');
          }
        }, ms);
      };
      this._clearStall = function () { clearTimeout(stallTimer); };

      xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloud.cloud) + '/image/upload');
      xhr.upload.onprogress = function (e) {
        if (token !== self._uploadToken) return;
        armStall(60000);
        if (e.lengthComputable && e.total > 0) {
          self.state.progress = Math.min(99, Math.round((e.loaded / e.total) * 100));
          self._renderProgress();
        }
      };
      xhr.upload.onload = function () { armStall(90000); };
      xhr.onload = function () {
        clearTimeout(stallTimer);
        if (token !== self._uploadToken) return;
        self._xhr = null;
        var data = null;
        try { data = JSON.parse(xhr.responseText); } catch (e) { data = null; }
        if (xhr.status >= 200 && xhr.status < 300 && data && data.secure_url) {
          self._succeed(data);
        } else {
          self._fail(Core.classifyUploadError(xhr.status, xhr.responseText));
        }
      };
      xhr.onerror = function () {
        clearTimeout(stallTimer);
        if (token !== self._uploadToken) return;
        self._xhr = null;
        self._fail('network');
      };
      armStall(60000);
      xhr.send(fd);
    }

    _abortUpload() {
      if (this._clearStall) this._clearStall();
      if (this._xhr) {
        var xhr = this._xhr;
        this._xhr = null;
        this._uploadToken++; // laufende Callbacks ignorieren
        try { xhr.abort(); } catch (e) { /* egal */ }
      }
    }

    _succeed(data) {
      this.state.busy = false;
      this.state.phase = 'done';
      this.state.progress = 100;
      // Maße aus der Cloudinary-Antwort gelten nach der EXIF-Drehung (geprüft) = Koordinatenraum für den Ausschnitt
      this.state.photo = { url: data.secure_url, width: data.width, height: data.height, publicId: data.public_id || '' };
      // HEIC ohne Browser-Vorschau: Format erst jetzt aus den Cloudinary-Maßen
      if (this.state.prepared && !this.state.prepared.width) this._applyAutoFormat(data.width, data.height);
      if (!this.state.previewUrl) this.state.remotePreview = Core.thumbUrl(data.secure_url);
      var work = this.state.prepared ? this.state.prepared.work : null;
      if (this.state.prepared) this.state.prepared.work = null; // gehört jetzt dem Editor
      this.state.prepared = null; // Blob freigeben
      if (this.editor) {
        var f = this._editorFrame();
        this.editor.setFrame(f.aspect, f.size);
        this.editor.setPhoto(this.state.photo, work);
      }
      this._render();
    }

    _freeWork(prepared) {
      if (prepared && prepared.work) {
        prepared.work.width = 0;
        prepared.work.height = 0;
        prepared.work = null;
      }
    }

    _fail(key) {
      this.state.busy = false;
      this.state.phase = 'error';
      this.state.error = key;
      this.state.photo = null;
      if (this.editor) this.editor.clear();
      this._render();
    }

    _revokePreview() {
      if (this.state && this.state.previewUrl) {
        try { URL.revokeObjectURL(this.state.previewUrl); } catch (e) { /* egal */ }
        this.state.previewUrl = null;
      }
      if (this.state) this.state.remotePreview = null;
    }

    /* ---------- Kauf-Button ---------- */
    _bindCta() {
      var self = this;
      this.cta.addEventListener('click', function (e) {
        var mode = self._ctaMode();
        if (mode === 'upload') {
          e.preventDefault();
          self._openPicker();
        } else if (mode !== 'add') {
          e.preventDefault();
        }
      });

      // Absicherung vor dem Theme-Handler (Capture am Vorfahren läuft vor dem jQuery-Submit am Formular):
      // ohne fertiges Foto wird nichts in den Warenkorb gelegt, sonst die Eigenschaften frisch setzen.
      this.addEventListener('submit', function (e) {
        if (e.target !== self.form) return;
        if (self._ctaMode() !== 'add' || !self.state.photo) {
          e.preventDefault();
          e.stopPropagation();
          if (!self.state.photo && !self.state.busy) {
            self.state.error = self.state.error || 'no_photo';
            self.state.phase = 'error';
            self._render();
          }
          return;
        }
        self._writeProperties();
        if (self.variant) self.select.value = String(self.variant.id);
      }, true);

      // Das Theme schreibt beim Variantenwechsel und nach dem Add eigenen Text in den Button -> wiederherstellen
      this._ctaObserver = new MutationObserver(function () { self._renderCta(); });
      this._ctaObserver.observe(this.cta, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    }

    _ctaMode() {
      return Core.ctaMode({ variant: this.variant, busy: this.state.busy, hasPhoto: !!this.state.photo });
    }

    _themeOwnsCta() {
      // Spinner während des Adds oder "Hinzugefügt"-Text: das Theme ist dran, nicht überschreiben
      return !!(this.cta.querySelector('.loading-spinner') || this.cta.classList.contains('btn--added'));
    }

    _ctaLabel(mode) {
      var s = this.s;
      switch (mode) {
        case 'upload': return s.ctaUpload;
        case 'uploading': return s.ctaUploading;
        case 'add': return s.ctaAdd;
        case 'soldout': return s.ctaSoldout;
        default: return s.ctaUnavailable;
      }
    }

    _renderCta() {
      if (!this.cta) return;
      if (!this._themeOwnsCta()) {
        var mode = this._ctaMode();
        var price = this.variant ? Core.formatMoney(this.variant.price, this.cfg.moneyFormat) : '';
        var label = this._ctaLabel(mode);
        var key = mode + '|' + label + '|' + price;
        var disabled = !(mode === 'upload' || mode === 'add');
        if (this.cta.getAttribute('data-mnz-key') !== key || !this.cta.querySelector('.mnz-cta__label')) {
          this.cta.setAttribute('data-mnz-key', key);
          this.cta.innerHTML = '';
          var iconHtml = this._ctaIcons ? this._ctaIcons[mode === 'upload' ? 'upload' : (mode === 'add' ? 'add' : '')] : '';
          if (iconHtml) {
            var ic = document.createElement('span');
            ic.className = 'mnz-cta__icon';
            ic.setAttribute('aria-hidden', 'true');
            ic.innerHTML = iconHtml;
            this.cta.appendChild(ic);
          }
          var l = document.createElement('span');
          l.className = 'mnz-cta__label';
          l.textContent = label;
          this.cta.appendChild(l);
          if (price) {
            var sep = document.createElement('span');
            sep.className = 'mnz-cta__sep';
            sep.setAttribute('aria-hidden', 'true');
            sep.textContent = '|';
            var p = document.createElement('span');
            p.className = 'mnz-cta__price';
            p.textContent = price;
            this.cta.appendChild(sep);
            this.cta.appendChild(p);
          }
        }
        if (this.cta.disabled !== disabled) this.cta.disabled = disabled;
        var soldout = mode === 'soldout' || mode === 'unavailable';
        if (this.cta.classList.contains('button--sold-out') !== soldout) this.cta.classList.toggle('button--sold-out', soldout);
        this.cta.setAttribute('data-mode', mode);
      }
      this._mirrorSticky();
    }

    /* ---------- Sticky-Button (Handy) ---------- */
    _setupSticky() {
      var tpl = this.querySelector('template[data-mnz-sticky-template]');
      if (!tpl || !('IntersectionObserver' in window)) return;
      var self = this;
      var frag = tpl.content.cloneNode(true);
      this._sticky = frag.firstElementChild;
      if (!this._sticky) return;
      document.body.appendChild(this._sticky);
      this._stickyBtn = this._sticky.querySelector('button');
      this._stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var mode = self._ctaMode();
        if (mode === 'upload') {
          self._openPicker();
        } else if (mode === 'add' && !self.cta.disabled) {
          self.cta.click(); // gleicher Weg wie der Haupt-Button (Theme-AJAX)
        }
      });
      this._stickyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          self._stickyVisible = !entry.isIntersecting;
          self._sticky.classList.toggle('is-visible', self._stickyVisible);
          self._sticky.setAttribute('aria-hidden', self._stickyVisible ? 'false' : 'true');
        });
      });
      this._stickyObserver.observe(this.cta);
    }

    _mirrorSticky() {
      if (!this._stickyBtn) return;
      if (this._stickyBtn.innerHTML !== this.cta.innerHTML) this._stickyBtn.innerHTML = this.cta.innerHTML;
      this._stickyBtn.disabled = this.cta.disabled;
      this._stickyBtn.classList.toggle('button--sold-out', this.cta.classList.contains('button--sold-out'));
    }

    /* ---------- Rendering ---------- */
    // Sichtbar: nur "Dein Foto: hochgeladen" + Format. Versteckt ("_"): Druck-URL (Ausschnitt inkl. Drehung), Original, Rohdaten.
    _writeProperties() {
      var photo = this.state.photo;
      var crop = '';
      var data = null;
      if (photo) {
        var EC = window.MnzEditorCore;
        if (this.editor && this.editor.photo) {
          crop = this.editor.cropUrl();
          data = this.editor.cropData();
        } else if (EC && photo.width && photo.height) {
          // Ohne Editor: mittiger Ausschnitt im gewählten Format
          var c = EC.cropInt(EC.cropRect(photo.width, photo.height, EC.defaultView(), this._editorFrame().aspect));
          crop = EC.cropUrl(photo.url, c);
          data = EC.cropData(c, photo);
        }
      }
      setProp(this.statusInput, photo ? this.statusValue : '');
      setProp(this.photoInput, photo ? (crop || photo.url) : '');
      setProp(this.originalInput, photo ? photo.url : '');
      setProp(this.cropInput, data ? JSON.stringify(data) : '');
      this.formatInput.value = this.state.format === 'landscape' ? this.s.formatLandscape : this.s.formatPortrait;
    }

    _renderProgress() {
      var bar = this.querySelector('[data-mnz-bar]');
      if (bar) bar.style.width = this.state.progress + '%';
      var progress = this.querySelector('[data-mnz-progress]');
      if (progress) progress.setAttribute('aria-valuenow', String(this.state.progress));
      var status = this.querySelector('[data-mnz-status]');
      if (status && this.state.phase === 'uploading') {
        status.textContent = this.s.uploadProgress + ' ' + this.state.progress + ' %';
      }
    }

    _render() {
      var m = this.model;
      var st = this.state;
      var sel = st.sel;
      var fmt = this.cfg.moneyFormat;
      var s = this.s;

      // Leinwand zweistufig: Karten, Aufklappen
      var view = this.canvas ? Core.canvasView(sel, this.canvas, st.lastSub) : null;
      if (view) {
        var groupInput = this.querySelector('[data-mnz-canvas-group]');
        if (groupInput) {
          var groupPossible = Core.pickSub(m, sel, this.canvas, st.lastSub) !== null;
          groupInput.checked = view.open;
          groupInput.disabled = !groupPossible && !view.open;
          if (groupInput.nextElementSibling) groupInput.nextElementSibling.classList.toggle('is-unavailable', !groupPossible && !view.open);
        }
        var cards = this.querySelectorAll('[data-mnz-canvas-card]');
        for (var cc = 0; cc < cards.length; cc++) {
          var isGroupCard = cards[cc].getAttribute('data-mnz-canvas-card') === 'stretched';
          cards[cc].classList.toggle('is-selected', isGroupCard ? view.open : view.rolled);
          if (isGroupCard) cards[cc].classList.toggle('is-open', view.open);
        }
        var subsEl = this.querySelector('[data-mnz-canvas-subs]');
        if (subsEl && subsEl.hidden === view.open) subsEl.hidden = !view.open;
      }

      // Optionen-Kacheln
      var inputs = this.querySelectorAll('[data-mnz-option-input]');
      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        var idx = parseInt(inp.getAttribute('data-option-index'), 10);
        var isSub = !!view && inp.hasAttribute('data-mnz-canvas-sub');
        inp.checked = isSub ? inp.value === view.sub : sel.values[idx] === inp.value;
        var status = Core.tileStatus(m, sel, idx, inp.value);
        inp.disabled = status === 'unavailable';
        var tile = inp.nextElementSibling;
        if (tile) {
          tile.classList.toggle('is-unavailable', status === 'unavailable');
          tile.classList.toggle('is-adjust', status === 'adjust');
        }
        var deltaEl = tile ? tile.querySelector('[data-mnz-delta]') : null;
        if (deltaEl) {
          // Unteroptionen der gespannten Leinwand: Aufpreis zur günstigsten Unteroption (z.B. "Fertig aufgebaut +€7,00").
          // Farben: nie ein Aufpreis (steht im Kauf-Button). Größe/Leinwand-Liste: nur mit Setting.
          var delta = null;
          if (isSub) delta = Core.groupDelta(m, sel, idx, inp.value, this.canvas.subs);
          else if (this.cfg.showOtherDeltas && idx !== m.colorsIndex) delta = Core.optionDelta(m, sel, idx, inp.value);
          var txt = status === 'unavailable' ? s.tileUnavailable : Core.formatDelta(delta, fmt, '');
          if (deltaEl.textContent !== txt) deltaEl.textContent = txt;
        }
      }

      // Nachfüllset
      var refill = this.querySelector('[data-mnz-refill-input]');
      if (refill) {
        var info = Core.refillInfo(m, sel);
        refill.checked = !!sel.refill;
        refill.disabled = !info.available && !sel.refill;
        var rd = this.querySelector('[data-mnz-refill-delta]');
        if (rd) rd.textContent = info.delta !== null ? Core.formatDelta(info.delta, fmt, '') : '';
        var compare = this.querySelector('[data-mnz-refill-compare]');
        if (compare) compare.hidden = !(info.delta !== null && this.cfg.refillCompareCents && this.cfg.refillCompareCents > info.delta);
        var wrap = this.querySelector('[data-mnz-refill]');
        if (wrap) wrap.classList.toggle('is-unavailable', !info.available && !sel.refill);
      }

      // Format
      var fInputs = this.querySelectorAll('[data-mnz-format-input]');
      for (var f = 0; f < fInputs.length; f++) fInputs[f].checked = fInputs[f].value === st.format;
      var note = this.querySelector('[data-mnz-format-note]');
      if (note) note.hidden = !(st.formatAuto && (st.photo || st.busy));

      // Live-Preise (Preis-Block)
      var root = this.closest('.product-detail') || this;
      var priceEls = root.querySelectorAll('[data-mnz-live-price]');
      for (var p = 0; p < priceEls.length; p++) {
        priceEls[p].textContent = this.variant ? Core.formatMoney(this.variant.price, fmt) : '';
      }
      var compareEls = root.querySelectorAll('[data-mnz-live-compare]');
      var hasCompare = !!(this.variant && this.variant.compare && this.variant.compare > this.variant.price);
      for (var c = 0; c < compareEls.length; c++) {
        compareEls[c].hidden = !hasCompare;
        compareEls[c].textContent = hasCompare ? Core.formatMoney(this.variant.compare, fmt) : '';
        if (compareEls[c].parentElement) compareEls[c].parentElement.classList.toggle('on-sale', hasCompare);
      }

      // Editor: Rahmen passend zu Größe und Format, sichtbar nur mit Foto
      if (this.editor) {
        var ef = this._editorFrame();
        this.editor.setFrame(ef.aspect, ef.size);
      }

      this._renderUpload();
      this._writeProperties();
      this._renderCta();
    }

    _renderUpload() {
      var st = this.state;
      var s = this.s;
      var el = this.uploadEl;
      if (!el) return;
      var phase = st.phase || 'empty';
      el.setAttribute('data-state', phase);

      var row = el.querySelector('[data-mnz-file-row]');
      var drop = el.querySelector('[data-mnz-drop]');
      var showRow = phase === 'processing' || phase === 'uploading' || phase === 'done';
      if (row) row.hidden = !showRow;
      if (drop) drop.hidden = showRow;

      var thumb = el.querySelector('[data-mnz-thumb]');
      var thumbPh = el.querySelector('[data-mnz-thumb-ph]');
      var src = st.previewUrl || st.remotePreview || '';
      if (thumb) {
        if (src && thumb.getAttribute('src') !== src) {
          thumb.onerror = function () { thumb.hidden = true; if (thumbPh) thumbPh.hidden = false; };
          thumb.src = src;
        }
        thumb.hidden = !src;
        if (thumbPh) thumbPh.hidden = !!src;
      }

      var status = el.querySelector('[data-mnz-status]');
      var progress = el.querySelector('[data-mnz-progress]');
      if (status) {
        if (phase === 'processing') status.textContent = s.uploadProcessing;
        else if (phase === 'uploading') status.textContent = s.uploadProgress + ' ' + st.progress + ' %';
        else if (phase === 'done') status.textContent = s.uploadDone;
      }
      if (progress) progress.hidden = !(phase === 'processing' || phase === 'uploading');
      this._renderProgress();
      el.classList.toggle('is-processing', phase === 'processing');

      var errBox = el.querySelector('[data-mnz-error]');
      var errText = el.querySelector('[data-mnz-error-text]');
      if (errBox) errBox.hidden = phase !== 'error';
      if (errText && phase === 'error') {
        var map = {
          heic_too_large: s.errHeicTooLarge,
          unsupported: s.errUnsupported,
          too_large: s.errTooLarge,
          network: s.errNetwork,
          no_photo: s.errNoPhoto,
          generic: s.errGeneric
        };
        errText.textContent = map[st.error] || s.errGeneric;
      }
      // Nach einem Fehler bleibt die Auswahlfläche sichtbar
      if (phase === 'error' && drop) drop.hidden = false;
    }
  }

  window.customElements.define('mnz-buybox', MnzBuybox);
})(typeof window !== 'undefined' ? window : globalThis);
